var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:(_vm.text),expression:"text",modifiers:{"right":true}}],staticClass:"fa fa-fw fa-info-circle tooltip-icon",style:(_vm.inline ? 'display: inline' : '')})
}
var staticRenderFns = []

export { render, staticRenderFns }